const s = {
  name: "Installments",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<g>
			<path class="st0" d="M22,0h-1v19h19v-1C40,8.1,31.9,0,22,0z M36,17c-0.5-6.9-6-12.5-13-13V2c8,0.5,14.5,7,15,15H36z M33.9,16.8
				c0,0.1,0,0.2,0,0.2H23V6C28.8,6.5,33.4,11.1,33.9,16.8z"/>
			<path class="st0" d="M40,21H21v19h1c9.9,0,18-8.1,18-18V21z M23,36c6.9-0.5,12.5-6,13-13h2c-0.5,8-6.9,14.5-15,15V36z M23,23h11
				c-0.5,5.8-5,10.4-10.7,10.9c-0.1,0-0.2,0-0.2,0L23,23L23,23z"/>
			<path class="st0" d="M0,21h19v19h-1C8.1,40,0,31.9,0,22V21z M17,36c-6.9-0.5-12.5-6-13-13H2c0.5,8,7,14.5,15,15V36z M17,34V23H6
				c0,0.1,0,0.2,0,0.2C6.6,29,11.2,33.5,17,34z"/>
			<path class="st0" d="M0,19v-1C0,8.1,8.1,0,18,0h1v19H0z M4,17c0.5-6.9,6-12.5,13-13V2C9,2.5,2.5,9,2,17H4z M6,17h11V6
				C11.2,6.5,6.6,11,6.1,16.7C6.1,16.9,6,16.9,6,17z"/>
		</g>
	</g>
</g>
</svg>
  `
};
export {
  s as Installments
};
